export default __webpack_public_path__ + "static/media/dependencyci.56792c1a.svg";